//#region Styles
import {
    ContainerLink  
} from "./styles";
//#endregion

const ListItem = ({ 
    to, text, 
    icon, active, 
    borderTop = false
}) => {
    const getClassName = () => {
        const classList = [];
        borderTop && classList.push("border-top");
        active && classList.push("active");
        return classList.join(" ");
    }
    return (
        <li>
            <ContainerLink 
                className={getClassName()}
                to={to} 
                replace={true}>
                {icon}
                <span className="description">{text}</span>
            </ContainerLink>
        </li>
    );
}

export default ListItem;